import { Box, Slider, Stack, Typography } from '@mui/material'
import { SyntheticEvent } from 'react'
import { IconButton } from 'utoniq-ui'

export const SoundPlayerControl = ({
  isPlaying,
  duration,
  sliderValue,
  onPlay,
  onPause,
  onRewind,
  onForward,
  onChange,
  onChangeCommitted,
}: {
  isPlaying: boolean
  duration: number
  sliderValue: number
  onPlay: () => void
  onPause: () => void
  onRewind: () => void
  onForward: () => void
  onChange: (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => void
  onChangeCommitted: (
    event: Event | SyntheticEvent<Element, Event>,
    value: number | number[]
  ) => void
}) => {
  return (
    <Box sx={{ display: 'grid', placeItems: 'center' }}>
      <Slider
        min={0}
        max={duration}
        defaultValue={0}
        value={sliderValue}
        onChange={onChange}
        onChangeCommitted={onChangeCommitted}
      />
      <Stack
        direction="row"
        sx={{
          width: 1,
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="caption">{secondToMmss(sliderValue)}</Typography>
        <Typography variant="caption">
          {Number.isFinite(duration) &&
            secondToMmss(Math.floor(duration) - Math.floor(sliderValue))}
        </Typography>
      </Stack>
      <Stack
        spacing={4}
        direction="row"
        sx={{
          justifyContent: 'center',
        }}
      >
        <IconButton.AudioRewind onClick={onRewind} />
        {isPlaying ? (
          <IconButton.AudioPause onClick={onPause} />
        ) : (
          <IconButton.AudioPlay onClick={onPlay} />
        )}
        <IconButton.AudioForward onClick={onForward} />
      </Stack>
    </Box>
  )
}

const secondToMmss = (second: number) =>
  [Math.floor(second / 60), Math.floor(second % 60)]
    .map(timeNum => String(timeNum).padStart(2, '0'))
    .join(':')
